import { z } from 'zod';

export const GetProjectFilesListResponseSchema = z.object({
  projectId: z.string().describe('Project id'),
  revisionId: z.string().describe('Code revision'),
  files: z.array(z.string()).describe('Array containing path to all files in project'),
});

export type GetProjectFilesListResponse = z.infer<typeof GetProjectFilesListResponseSchema>;
